import { v4 as uuid } from "uuid";
import React, { useEffect, useState, useRef} from "react";
import store from "@/redux/store";

import { loadTranslation } from '@/reducers/Translation'

import { useNavigate, Link } from "react-router-dom";
import PPCEditor from "@/views/base/editor/Editor"
import { useForm, Controller, SubmitHandler } from "react-hook-form"
import { wpUpdate } from '@/reducers/WorkProcess'
import { EditorState, RichUtils, convertToRaw, convertFromRaw, convertFromHTML, ContentState, Immutable, Draft   } from 'draft-js';

import draftToHtml from '@/components/draftjs-to-html/lib/draftjs-to-html.js';
import htmlToDraft from 'html-to-draftjs';

import { Editor } from 'react-draft-wysiwyg';
import '@/styles/wysiwyg/react-draft-wysiwyg.css';
//var dgram = require('dgram');
import {messageActions} from "@/redux/messageSlice";

import {MapTree} from '@/components/tree/Maps';
import { DateBox } from "@/components/holders/DateBox";

import { CogIcon } from '@heroicons/react/20/solid'
import {TimeField, Button, Calendar, CalendarCell, CalendarGrid, DateInput, DatePicker, DateSegment, Dialog, Group, Heading, Label, Popover} from 'react-aria-components';
import {DatePickerExample} from '@/components/datetime/datepicker';
import { SectorSelect } from "../base/panels/SectorSelect";
import { UserSelect } from "../base/panels/UserSelect";
import {SmallUserTable} from '@/components/holders/SmallUserTable';
import { WorkFlowItem } from "@/components/Workflow/WorkFlow";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useTranslation, withTranslation, Trans } from "react-i18next";
import i18n from 'i18next';

import { PPCTimeField } from "@/components/datetime/PPCTimeField";

import { createPortal } from 'react-dom';
import {Time} from '@internationalized/date';
import { Switch, Field } from '@headlessui/react'
import {SelectBox} from '@/components/holders/SelectBox'

import Schedule from '@/components/timeline/Schedule';
import DossierHelper from '@/helpers/DossierHelper';

import { ChevronDownIcon } from '@heroicons/react/16/solid'
//require("frappe-gantt");
//import "@/styles/frappe-gantt.css"
//import "frappe-gantt/dist/frappe-gantt.css";
 
// make sure you include the timeline stylesheet or the timeline will not be styled
//import 'react-calendar-timeline/lib/styles.css'
import moment from 'moment' 
 
 function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
const tabs = [


  {tabId: 1, name: 'TODO', href: '#', current: true },
  {tabId: 2, name: 'Contactblad', href: '#', current: false },
  {tabId: 3,  name: 'Afspraken', href: '#', current: false }
] 
 
export function View({...props}) {
    const [selectedTab, setSelectedTab] = useState(1)

    
    const [showScheduler, setShowScheduler] = useState(false);
    const [keyName, setKeyName] = useState(uuid().slice(0, 8));
    const [item, setItem] = useState(null);
    const [timelineItem, setTimelineItem] = useState(item);
    const { t, i18n, ready } = useTranslation();
    let updateKey = uuid().slice(0, 8);
    const myRef = useRef(null);
    let timeoutId = null;

const handleBut=(html) => {

}
    // code to run after render goes here
const groups = [{ id: 1, title: 'group 1' }, { id: 2, title: 'group 2' }]

const itemsGantt = [
  {
    id: 1,
    group: 1,
    title: 'item 1',
    start_time: moment(),
    end_time: moment().add(1, 'hour')
  },
  {
    id: 2,
    group: 2,
    title: 'item 2',
    start_time: moment().add(-0.5, 'hour'),
    end_time: moment().add(0.5, 'hour')
  },
  {
    id: 3,
    group: 1,
    title: 'item 3',
    start_time: moment().add(2, 'hour'),
    end_time: moment().add(3, 'hour')
  }
]   

//

  const { register, handleSubmit, watch, reset,    formState, setValue, getValues, control } = useForm({
      defaultValues: {...props?.translations?.menu},
    })
    
    const changeEventOnCustomer =((name, selected) => {
        
        if(selected?.type == 0) {
            setValue('tenantcompany_key', selected.key);
            setValue('customer_key', null);
        } else {
            setValue('customer_key', selected.key);
            setValue('tenantcompany_key', null);
        }
        });
        
    const getDefaultCustomer =(() => {
        let selectedCustomer = getValues('customer_key');
        if(!selectedCustomer) {
            selectedCustomer = getValues('tenantcompany_key');
        }    
        return selectedCustomer;
    });        
    
    
    const setChildEnabled =((children, isEnabled) => {
        for(let i in children) {
            children[i].children = setChildEnabled(children[i]['children'], isEnabled);
            setValue(children[i].indexKey+".enabled", isEnabled);
            
            //children[i] = {... children[i], enabled: isEnabled}
            }
            return children;
        });
    
const setSelectedItem =((item, children) => {
    if(item?.children) {
        setChildEnabled(item?.children, item.enabled);
    }
    setValue(item.indexKey+".enabled", item.enabled);
    setKeyName(item.ref+item.enabled);
});    
    
const selectedItem = ((item, isOpen, keyNameVal) => {
    let indexKey = item.indexKey;
    let selectedItem = item;
    if(indexKey == "") {
        setItem(item);
//        indexKey = field;
    } else {
        selectedItem = getValues(indexKey);
        setItem(getValues(indexKey));
//        indexKey = "."+field;
    }
  //  
    
    if(selectedItem?.children && Array.isArray(selectedItem?.children) && selectedItem?.children.length > 0) {
        setTimelineItem(selectedItem);
    }

    return false;    
})
const onSubmit = (data) => {
//    store.dispatch(messageActions.receiveMessage2())
    
    
    if(props?.onSaveHandler) {
        props.onSaveHandler(data);
    }
    
    //setUKey(uuid().slice(0, 8));
    return false;
    }
 
 const onChange=(event) => {
     if(event?.nativeEvent && event.nativeEvent.type == "input") {
        let newItem = {...item}
        newItem[event.target.name] = event.target.value;
         updateItem(newItem, event.target.name);
         setItem({lblKey:event.target.name, lbl: event.target.value});
     } else if(event?.item){
         if(!event.item.indexKey || event.item.indexKey == "") {
            for(let i in event.fields) {
             setValue(event.fields[i], event.item[event.fields[i]]);   
            }
             
         } else {
            setValue(event.item.indexKey, {...event.item});
         }
     }
     }
     
// handles JSON.stringify/parse
let items = new Array(props.selected);

const onChangeDateEvent=((event, name) => {
    let newItem = {...item}
    newItem.updateKey = uuid().slice(0, 8);
    newItem[name] = moment(event.toString()).valueOf();
    updateItem(newItem, name);
    //setValue(indexKey, moment(event.toString()).valueOf());
});

const updateItem=((changedItem, field, item = null) => {
    let indexKey = changedItem.indexKey;
    if(indexKey == "") {
        indexKey = field;
    } else {
        indexKey = "."+field;
    }
    setValue(indexKey, changedItem[field]);
});

const updateItemSingleValue=((changedItem, field, value) => {

    let indexKey = changedItem.indexKey;
    
    if(indexKey == "") {
        indexKey = field;
    } else {
        indexKey = indexKey+"."+field;
    }
    
    setValue(indexKey, value);


    let newItem = {...changedItem}
    newItem.updateKey = uuid().slice(0, 8);
    newItem[field] = value;


    setItem(newItem);
    
        
    

    
});


const setSettingsForAllChildren=((itemToChange, parentItem = null) => {
    if(!parentItem) {
        console.log("item change", getValues());
        parentItem = getValues();
    }
    
    
    for(let i in itemToChange.children) {

            setValue(itemToChange.children[i].indexKey+'.sector_key', parentItem['sector_key']);
            setValue(itemToChange.children[i].indexKey+'.department_key', parentItem['department_key']);
            setValue(itemToChange.children[i].indexKey+'.start_date', parentItem['start_date']);
            setValue(itemToChange.children[i].indexKey+'.end_date', parentItem['end_date']);
            //
            if(Array.isArray(itemToChange.children[i]?.children) && itemToChange.children[i]?.children.length > 0) {    
                setSettingsForAllChildren(itemToChange.children[i], parentItem);
            }
    }
})

    console.debug("verander ",getValues());
const onCancelEvent=((event) => {
    i18n.reloadResources();
   if(props?.onCancelHandler) {
       props.onCancelHandler();
   } 
});

const setIndexKeyHandler=((newIndexKey) => {
    
})

const setValue2=((fieldName, html, options = null) => {
   
   
   console.debug(html) ;
   console.debug(options) ;
});

let tasks = [
  {
    id: '1',
    name: 'Redesign website',
    start: '2016-12-28',
    end: '2016-12-31',
    progress: 20
  },
];

//new Time(0,0,0,0)

 const handleKeyDown = (event) => {
     return;
        if(event.target.dataset.type == 'minute') {
            let values = event.target.dataset[event.target.dataset.type];
            if(values) {
                values = values.split(",");
                let valueIndex = parseInt(event.target.dataset.valueIndex);
                if(!valueIndex) {
                    valueIndex = 0;
                } else 
                if(event.target.dataset.valueIndex == valueIndex) {
                    valueIndex += 1;
                    if(valueIndex >= values.length) {
                        valueIndex = 0;
                    }
                }
                event.preventDefault();
                event.stopPropagation();
                event.target.dataset.valueIndex = valueIndex;
                event.target.val =( values[valueIndex] );
                event.target.html =( values[valueIndex] );
                //event.target.dataset['aria-valuetext'] = values[valueIndex]; 
                event.target.dataset['ariavaluenow'] = values[valueIndex];
                
                console.log( values[valueIndex] )
                console.debug("asdadajdhjasdhjahd", new Time(0,values[valueIndex],0,0));
                setWHours( new Time(0,values[valueIndex],0,0) )
                console.debug("asdadajdhjasdhjahd", new Time(0,values[valueIndex],0,0));
                
            }
           console.log(event) ;
        }
        
        return false;
    };
    
    let labels = getValues();
    const onSelectLbl = (event, lblKey) => {
        setItem({lblKey:lblKey, lbl: labels[lblKey]});
    }
    

  return (
    <>

<div className="space-y-1 divide-y divide-gray-900/10">

    <div className="grid grid-cols-1 gap-x-2 gap-y-2 ring-1 ring-gray-900/5 sm:rounded-xl md:grid-cols-">
        <form className="bg-white shadow-sm  md:col-span-2" onSubmit={handleSubmit(onSubmit)}>

        <div className=" w-full p-2 h-12 border-b-2 border-gray-600/5 border-solid grid grid-cols-12">
            <div className="col-span-9">
            <h1>Vertalingen</h1>
            </div>
            
            <div className="col-span-3 w-full grow flex flex-row place-content-end">
                        <Link 
                                onClick={(e) => {onCancelEvent(e)}}
                                className="text-center min-w-24 rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-2 ">
                        Herladen vertalingen<span className="sr-only">, {""}</span>
                      </Link>
                      
                <button
                  //onClick={(event) => {handleBut(event)}}
                  type="submit"
                  className="text-center min-w-24 mr-2 rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Opslaan
                </button>                      
                      
                      </div>
        </div>
        
            <div className="flex h-full min-h-0 ">
                    <div className="flex flex-col w-96 mr-1 top-0 border-r-2 border-gray-600/5 border-solid max-lg:hidden" >
                        <div className="sticky h-full p-2">
                            {labels && Object.keys(labels).map((labelKey) => (
                                 <div onClick={(event) => onSelectLbl(event, labelKey)}>
                                    {labels[labelKey]}
                                </div>
                           ))}

                        </div>
                    </div>
                    <div className="flex flex-col w-full p-5 pt-2" style={{minHeight: "400px"}} key={(item && item.ref) ? item.ref : null}>
                        {item &&

            <FieldHolder colspan="12" smcolspan="8" label={'Vertaling label'} id="name" error={props?.state?.error}>                
                 <input
                    id={item.lblKey}
                    name={item.lblKey}
                    type="text"
                    defaultValue={item.lbl}
                    onChange={(event) => onChange(event)}
                    //data-dashlane-disabled-on-field="true"
                    key={(item && item.lblKey) ? item.lblKey+"_name" : null}
                    className="component block w-full rounded-md border-0 py-.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>      
                        
                        
                        }
                    </div>
              </div>
              </form>
              </div>
          </div>      
    </>
      );
}